export const maintenanceConfig = {
  isMaintenanceInProgress: false,
  plannedMaintenanceDuration: 0, // number, minutes
  plannedMaintenanceWillStartAt: "", // ISO 8601 string, e.g. "2025-03-01T14:00:00Z"
};
